// extracted by mini-css-extract-plugin
export default {"paymentPage":"Payment_paymentPage__FHt-Y","paymentContainer":"Payment_paymentContainer__hmGyi","expItems":"Payment_expItems__JQE3r"};